module.exports = __webpack_public_path__ + "static/media/folderindex-folder-small.887e36a1.svg";